// extracted by mini-css-extract-plugin
module.exports = {"graphsBlock":"GraphsBlock_graphsBlock__3tX3B"};